import { Col, Descriptions, Row, Typography } from "antd";
import React from "react";
import { formatBoolean, formatDate } from "../shared/formatting";
import LabelWithEditAction from "../shared/form/LabelWithEditAction";
import { BulkUpdateActionType } from "./bulkUpdate/BulkUpdateModalConfig";

const formatProducerDisplay = (code, name) => {
  if (!name) return "";

  return code && code.trim() ? `${code} - ${name}` : name;
};

const hasValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

const RenewalPolicyDetailsPanel = ({ selected, onEditAction }) => {
  const handleDocumentOpen = (documentKey) => {
    window.open(
      `${process.env.REACT_APP_BASENAME}documents/updatedocumentform/${documentKey}`,
      `${documentKey}`
    );
  };

  return (
    <Row>
      <Col span={24}>
        {selected && (
          <Descriptions
            size="small"
            column={3}
            items={[
              {
                key: "policyNumber",
                label: "Policy Number",
                children: selected.PolicyNumber,
              },
              {
                key: "producerCode1",
                label: (
                  <LabelWithEditAction
                    text="Producer Code 1"
                    onEdit={() => onEditAction(BulkUpdateActionType.PRODUCER_1)}
                  />
                ),
                labelStyle: { overflow: "visible" },
                children: formatProducerDisplay(
                  selected.ProducerCode1,
                  selected.ProducerName1,
                ),
              },
              {
                key: "rateClass",
                label: "Rate Class",
                children: selected.RateClass,
              },

              {
                key: "plateNumber",
                label: "Plate Number",
                children: selected.PlateNumber,
              },

              {
                key: "producerCode2",
                label: (
                  <LabelWithEditAction
                    text="Producer Code 2"
                    onEdit={() => onEditAction(BulkUpdateActionType.PRODUCER_2)}
                  />
                ),
                labelStyle: { overflow: "visible" },
                children: formatProducerDisplay(
                  selected.ProducerCode2,
                  selected.ProducerName2,
                ),
              },
              {
                key: "ratingTerritory",
                label: "Territory",
                children: selected.RatingTerritory,
              },
              {
                key: "eligibleForOnlineRenewal",
                label: "Eligible For Online Renewal",
                children: formatBoolean(selected.EligibleForOnlineRenewal),
              },
              ...(hasValue(selected?.FleetNumber) || hasValue(selected?.FleetUnitNumber)
                ? [{
                    key: "fleetNumber",
                    label: "Fleet # / Unit #",
                    children: [selected.FleetNumber, selected.FleetUnitNumber]
                      .filter((value) => value !== null && value !== undefined && value !== "")
                      .join(" / ") || "",
                  }]
                : []),
              ...(hasValue(selected?.FleetGaragePolicyNumber)
                ? [{
                    key: "garagePolicyNumber",
                    label: "Garage Policy Number",
                    children: selected.FleetGaragePolicyNumber,
                  }]
                : []),
            ]}
          />
        )}
      </Col>
    </Row>
  );
};

export default RenewalPolicyDetailsPanel;
